/**
 * Created by juniusang on 5/4/17.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { StyleSheet, View } from 'react-native';
import R from '../../core-res/R';
import { withTheme } from '../../theme';
import Elevation from './elevations';
class DRNCardView extends React.Component {
    render() {
        const _a = this.props, { style, elevation, theme } = _a, rest = __rest(_a, ["style", "elevation", "theme"]);
        const cardStyle = {
            backgroundColor: theme.lightPrimary,
        };
        return <View {...rest} style={[styles.card, styles[elevation], cardStyle, style]}/>;
    }
}
DRNCardView.defaultProps = {
    elevation: Elevation.container,
};
const styles = StyleSheet.create({
    card: {
        borderRadius: R.border.radius.default,
        overflow: 'hidden',
    },
    // There's no shadow in flat and it's weird to put empty object inside token
    // so we hardcoded here
    flat: {},
    // interactive is deprecated. use raised instead
    interactive: R.elevation.interactive,
    raised: R.elevation.raised,
    float: R.elevation.float,
    hover: R.elevation.hover,
    container: R.elevation.container,
});
export default withTheme(DRNCardView);
